import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';

import { AuthProvider, AuthContext } from './context/AuthContext';
import Navbar from './components/Navbar';
import BottomMobileNav from './components/BottomMobileNav';
import Dashboard from './components/Dashboard';

import LoginPage from './pages/LoginPage';
import ProductMaster from './pages/ProductMaster';
import CustomerMaster from './pages/CustomerMaster';
import VendorMaster from './pages/VendorMaster';
import EmployeeMaster from './pages/EmployeeMaster';

import BoatExpensesEntry from './pages/BoatExpensesEntry';
import SaleEntry from './pages/SaleEntry';
import PurchaseEntry from './pages/PurchaseEntry';
import BoxEntry from './pages/BoxEntry';

import PaymentReceipts from './pages/PaymentReceipts';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useContext(AuthContext);
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function AppContent() {
  const { isAuthenticated } = useContext(AuthContext);

  return (
    <div className="min-vh-100 bg-light d-flex flex-column">
      {isAuthenticated && <Navbar />}
      <div className="flex-grow-1">
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          {/* PROTECTED APP ROUTES */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* MASTERS */}
          <Route
            path="/masters/products"
            element={
              <ProtectedRoute>
                <ProductMaster />
              </ProtectedRoute>
            }
          />
          <Route
            path="/masters/customers"
            element={
              <ProtectedRoute>
                <CustomerMaster />
              </ProtectedRoute>
            }
          />
          <Route
            path="/masters/vendors"
            element={
              <ProtectedRoute>
                <VendorMaster />
              </ProtectedRoute>
            }
          />
          <Route
            path="/masters/employees"
            element={
              <ProtectedRoute>
                <EmployeeMaster />
              </ProtectedRoute>
            }
          />

          {/* ENTRIES */}
          <Route
            path="/entry/boat-expenses"
            element={
              <ProtectedRoute>
                <BoatExpensesEntry />
              </ProtectedRoute>
            }
          />
          <Route
            path="/entry/sales"
            element={
              <ProtectedRoute>
                <SaleEntry />
              </ProtectedRoute>
            }
          />
          <Route
            path="/entry/purchases"
            element={
              <ProtectedRoute>
                <PurchaseEntry />
              </ProtectedRoute>
            }
          />
          <Route
            path="/entry/boxes"
            element={
              <ProtectedRoute>
                <BoxEntry />
              </ProtectedRoute>
            }
          />

          {/* PAYMENTS */}
          <Route
            path="/payments/*"
            element={
              <ProtectedRoute>
                <PaymentReceipts />
              </ProtectedRoute>
            }
          />

          {/* REPORTS */}
          <Route
            path="/reports/sales"
            element={
              <ProtectedRoute>
                <ReportsPage type="sales" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/purchases"
            element={
              <ProtectedRoute>
                <ReportsPage type="purchases" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/customer-ledger"
            element={
              <ProtectedRoute>
                <ReportsPage type="customer-ledger" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/vendor-ledger"
            element={
              <ProtectedRoute>
                <ReportsPage type="vendor-ledger" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/employees"
            element={
              <ProtectedRoute>
                <ReportsPage type="employees" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/accounts"
            element={
              <ProtectedRoute>
                <ReportsPage type="accounts" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/stock"
            element={
              <ProtectedRoute>
                <ReportsPage type="stock" />
              </ProtectedRoute>
            }
          />

          {/* SETTINGS */}
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            }
          />

          {/* DEFAULT REDIRECT */}
          <Route path="*" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />} />
        </Routes>
      </div>
      {isAuthenticated && <BottomMobileNav />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
